module.exports = __webpack_public_path__ + "img/xinwen.b0ef6442.png";